const recommendationSectionContainer = {
  gap: '1.5rem',
  padding: { xs: '2rem 1rem', md: '2rem 2rem' },
};

const recommendationsGrid = {
  display: 'grid',
  gridTemplateColumns: { phone: '1fr', m: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
  gap: { xs: '2rem', m: '1.5rem' },
};

const recommendationCard = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '1rem',
  width: '100%',
  maxWidth: { xs: '100%', lg: '18rem' },
  height: '100%',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.02)',
  },
};

const imageContainer = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '12rem',
  background: 'linear-gradient(106deg, #1B3060 8.51%, #090D17 95%)',
  borderRadius: '0.75rem',
  overflow: 'hidden',
};

const imageStyles = {
  objectFit: 'contain',
  width: '100%',
  height: '100%',
  transform: 'translateY(0.6rem)',
};

export {
  recommendationSectionContainer,
  recommendationsGrid,
  recommendationCard,
  imageContainer,
  imageStyles,
};
